export const reduceFeaturesResponse = ({
  data,
  productLine,
  highlightedProducts,
  state
}) => {
  const newFeatures = Object.assign({}, state.features, {
    [productLine]: data
  });
  const newHighlightedProducts = Object.assign({}, state.highlightedProducts, {
    [productLine]: highlightedProducts
  });
  return Object.assign({}, state, {
    features: newFeatures,
    highlightedProducts: newHighlightedProducts
  });
};
export const reduceFeaturesWithDefaultsResponse = ({
  data,
  state
}) => {
  return Object.assign({}, state, {
    defaults: data.reduce((acc, feature) => {
      if (feature.shortName) {
        acc[feature.shortName] = feature;
      }
      return acc;
    }, {})
  });
};